module.exports = __webpack_public_path__ + "img/logo_shield_text_white.73a7230b.svg";